// autogenerated
import {AthenaeumConstants, ServiceProvider, GeoCoordinate} from "@reapptor-apps/reapptor-toolkit";

export default class CheckInRequest {

    public bookingId: string = "";

    public location: GeoCoordinate | null = null;

    public readonly isCheckInRequest: true = true;

    public static is(from?: object | null): boolean {
        // noinspection PointlessBooleanExpressionJS
        return (from != null) && ((from instanceof CheckInRequest) || ((from as any).isCheckInRequest === true));
    }

    public static as(from?: object | null): CheckInRequest | null {
        return (CheckInRequest.is(from)) ? from as CheckInRequest : null;
    }

    // #region Placeholder

    // Put your code here (function, properties, ect...)

    // #endregion
}

ServiceProvider.addType(CheckInRequest, "CheckInRequest");